import { api } from '@app/config/axios';
import { getApiError } from '@shared/helpers/get-api-error';
import { SendChangeUserDataPostParams } from './@types/send-change-user-data.types';

export async function sendChangeUserData(params: SendChangeUserDataPostParams) {
  try {
    await api.post('/user-data-change', params);
  } catch (error) {
    getApiError(error);
  }
}
